import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  PieChart as RePieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

interface PieChartProps {
  leadCount: any[];
  status?: string;
}

const COLORS = ["#065f46", "#3730a3", "#374151"];

const PieChart: React.FC<PieChartProps> = ({ leadCount = [] }) => {
  // Convert your reduce logic into recharts data
  const data = useMemo(() => {
    const hot = leadCount.reduce(
      (sum, item) => sum + (item.highIntent || 0),
      0
    );

    const warm = leadCount.reduce(
      (sum, item) => sum + (item.mediumIntent || 0),
      0
    );

    const interested = leadCount.reduce(
      (sum, item) => sum + (item.lowIntent || 0),
      0
    );

    return [
      { name: "High Intent", value: hot },
      { name: "Medium Intent", value: warm },
      { name: "Low Intent", value: interested },
    ];
  }, [leadCount]);

  return (
    <div className="chart-container">
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height={330}>
          <RePieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={60} // donut hole
              outerRadius={90}
              paddingAngle={3}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>

            <Tooltip
              contentStyle={{
                borderRadius: 12,
                border: "1px solid rgba(0,0,0,0.08)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              }}
            />

            <Legend verticalAlign="bottom" iconType="circle" />
          </RePieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PieChart;
